import "./index.scss";

import React from "react";
import { connect } from "react-redux";
@connect((store) => {
    return {
        user: store.loggedUser.data,
        project: store.project,
        reminder: store.reminder,
        loggedUser: store.loggedUser
    }
})

export default class NotAvailable extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div class="row m0">
                <div class="col-lg-12 col-md-12 col-sm-12 pd0">
                    <div class="no-project">
                        <div class="no-project-content">
                            <i class="material-icons-outlined" aria-hidden="true">info</i>
                            <div class="mt20 mb20"><span>Page Not Available</span></div>
                            <div class="no-project-note">
                                <p>Your access may have been removed or the page you're trying to access has been deleted.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}